export default "/50f517735fec46580f19aae3e56e9fe21614ea75/74cc88c7571ddfe8037db442e45677ad.svg";